import React from 'react'
import { Redirect } from 'react-router-dom'

import App from './App.jsx'

import NotFound from './NotFound.jsx'
import Careers from './pages/careers'
import Pricing from './pages/pricing'
import Press from './pages/press'
import About from './pages/about'
import Games from './pages/games'
import FAQ from './pages/faq'
import Index from './pages/index'
import Privacy from './pages/privacy'
import Terms from './pages/terms'
import Scholarships from './pages/scholarships'

export const routes = [
  {
    component: App,
    routes: [
      {
        path: '/smite',
        component: Index
      },
      {
        path: '/pricing',
        exact: true,
        component: Pricing
      },
      {
        path: '/careers',
        exact: true,
        component: Careers
      },
      {
        path: '/press',
        exact: true,
        component: Press
      },
      {
        path: '/about',
        exact: true,
        component: About
      },
      {
        path: '/games',
        exact: true,
        component: Games
      },
      {
        path: '/privacy',
        exact: true,
        component: Privacy
      },
      {
        path: '/terms',
        exact: true,
        component: Terms
      },
      {
        path: '/help',
        component: () => {
          return <Redirect to="/faq" />
        }
      },
      {
        path: '/faq',
        component: FAQ
      },
      {
        path: '/scholarships',
        component: Scholarships
      },
      {
        path: '/',
        component: Index
      },
      {
        component: NotFound
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/common/ui/routes.js